import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';

import { useParams } from 'react-router-dom'

import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

import { useDispatch, useSelector } from "react-redux";

import { portfolioItemActions } from "../../../_actions";

import Spinner from "../Spinner";

import "./PortfolioItemsList.css";

const PortfolioItemsList = (props) => {
  const portfolioitems = useSelector((state) => state.portfolioitems);
  const loading = useSelector((state) => state.portfolioitems.loading);
  const dispatch = useDispatch();
  const { portfolioId } = useParams();
  
  const portfolioItemListData = portfolioitems.items ? portfolioitems.items : [];

  const mounted = useRef();

  useEffect(() => {
    // only on componentDidMount event
    if (!mounted.current) {
      mounted.current = true;
      dispatch(portfolioItemActions.getByPortfolioId(portfolioId));
    } else {
      // do componentDidUpate logic
    }
  }, [dispatch, portfolioId]);

  // list of items with the before images for the left panel
  let listBeforeItems = portfolioItemListData
  .filter((item) => {
    return (item.isActive === 1 && item.isBefore === 1);
  }).map((item) => {
    let url = require("../../../static/images/portfolioitems/fullsize/"+item.imageFileName);
    return { original: url, thumbnail: url };
  });

  // list of items with the after images for the right panel
  let listAfterItems = portfolioItemListData
  .filter((item) => {
    return (item.isActive === 1 && item.isBefore !== 1);
  }).map((item) => {
    let url = require("../../../static/images/portfolioitems/fullsize/"+item.imageFileName);
    return { original: url, thumbnail: url };
  });

  const beforeItemsPanel = ((items) => {
    if(items.length > 0) {
      return(
        <Col className="portfolio-items-col">
          <ImageGallery 
            items={items}
            showNam={false}
            showThumbnails={false}
            showFullscreenButton={false}
            showPlayButton={false} />
        </Col>
      );  
    }
    return '';
  });
  
  const afterItemsPanel = ((items) => {
    if(items.length > 0) {
      return(
        <Col className="portfolio-items-col">
          <ImageGallery
            items={items}
            showBullets={false}
            showPlayButton={false} />
        </Col>
      );  
    }
    return '';
  });
  
  if (loading) {
    return <Spinner />;
  }

  return (
    <Container className="portfolio-items-list-container">
      <Row className='justify-content-md-center portfolio-item-list-row'>
          { listBeforeItems.length !== 0 ? beforeItemsPanel(listBeforeItems) : '' }
          { listAfterItems.lehgth !== 0 ? afterItemsPanel(listAfterItems) : '' }
      </Row>
    </Container>
  );
};

export default PortfolioItemsList;
